export const DEFAULT_NOTIFICATIONS = 0

const USER_EDIT_LINK = {
  text: 'NAVIGATION_USER_MOTOS_EDIT_TEXT',
  url: 'NAVIGATION_USER_MOTOS_EDIT_URL'
}

const USER_FAVORITES_LINK = {
  text: 'NAVIGATION_USER_MOTOS_FAVORITES_TEXT',
  url: 'NAVIGATION_USER_MOTOS_FAVORITES_URL'
}

const USER_ALERTS_LINK = {
  text: 'NAVIGATION_USER_MOTOS_ALERTS_TEXT',
  url: 'NAVIGATION_USER_MOTOS_ALERTS_URL'
}

const USER_MESSAGES_LINK = {
  text: 'NAVIGATION_USER_MOTOS_MESSAGES_TEXT',
  url: 'NAVIGATION_USER_MOTOS_MESSAGES_URL'
}

export const USER_ADS_LINK = {
  text: 'NAVIGATION_USER_MOTOS_ADS_TEXT',
  url: 'NAVIGATION_USER_MOTOS_ADS_URL'
}

const USER_LOGOUT_LINK = {
  text: 'NAVIGATION_USER_MOTOS_LOG_OUT_TEXT',
  url: 'NAVIGATION_USER_MOTOS_LOG_OUT_URL',
  // Tracks `Signed Out` and clears the Segment identity cookies (ajs_user_id) before the browser
  // leaves for the /logout.aspx monolith page, which has no React tracking of its own.
  // No `event` key on purpose: an event would be dispatched on the next frame and lost to the navigation.
  trackingData: {reset: true}
}

export const NAVIGATION_NEWS_BLOG = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_URL'
}

export const NAVIGATION_NEWS_MOST_NEW = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_MOST_NEW_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_MOST_NEW_URL'
}
export const NAVIGATION_NEWS_TESTS = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_TEST_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_TEST_URL'
}
export const NAVIGATION_NEWS_ACTUALITY = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_ACTUALITY_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_ACTUALITY_URL'
}
export const NAVIGATION_NEWS_REPORTAGE = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_REPORTAGE_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_REPORTAGE_URL'
}
export const NAVIGATION_NEWS_VIDEOS = {
  text: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_VIDEOS_TEXT',
  url: 'NAVIGATION_MAIN_NEWS_MOTOS_BLOG_VIDEOS_URL'
}

/**
 * @exports main
 */
export const main = [
  {
    icon: 'search',
    label: 'NAVIGATION_MAIN_SEARCH_TITLE',
    menu: [
      {
        title: 'NAVIGATION_MAIN_SECOND_HAND_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_SECOND_HAND_MOTORBIKES_TEXT',
            url: 'NAVIGATION_MAIN_SECOND_HAND_MOTORBIKES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SECOND_HAND_QUADS_TEXT',
            url: 'NAVIGATION_MAIN_SECOND_HAND_QUADS_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SECOND_HAND_BUGGIES_TEXT',
            url: 'NAVIGATION_MAIN_SECOND_HAND_BUGGIES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SECOND_HAND_POCKETBIKES_TEXT',
            url: 'NAVIGATION_MAIN_SECOND_HAND_POCKETBIKES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SECOND_HAND_CLASSIC_TEXT',
            url: 'NAVIGATION_MAIN_SECOND_HAND_CLASSIC_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_NEW_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_NEW_MOTORBIKES_TEXT',
            url: 'NAVIGATION_MAIN_NEW_MOTORBIKES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_NEW_QUADS_TEXT',
            url: 'NAVIGATION_MAIN_NEW_QUADS_URL'
          },
          {
            text: 'NAVIGATION_MAIN_NEW_BUGGIES_TEXT',
            url: 'NAVIGATION_MAIN_NEW_BUGGIES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_NEW_POCKETBIKES_TEXT',
            url: 'NAVIGATION_MAIN_NEW_POCKETBIKES_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_SEARCH_PLACES_MOTOS_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_DEALERS_SEARCH_MOTOS_TEXT',
            url: 'NAVIGATION_MAIN_DEALERS_SEARCH_MOTOS_URL'
          }
        ]
      }
    ]
  },
  {
    icon: 'play',
    label: 'NAVIGATION_MAIN_INFO_MOTOS_TITLE',
    menu: [
      {
        title: 'NAVIGATION_MAIN_TECHNICAL_DATA_MOTOS_TITLE',
        links: [
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_MOTOS_PRICES_TEXT',
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_MOTOS_PRICES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_SEARCH_TEXT',
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_SEARCH_URL'
          },
          {
            hideOnMobile: true,
            text: 'NAVIGATION_MAIN_TECHNICAL_DATA_MOTOS_COMPARISON_TEXT',
            url: 'NAVIGATION_MAIN_TECHNICAL_DATA_MOTOS_COMPARISON_URL'
          }
        ]
      },
      {
        title: 'NAVIGATION_MAIN_NEWS_MOTOS_TITLE',
        links: [
          NAVIGATION_NEWS_BLOG,
          NAVIGATION_NEWS_MOST_NEW,
          NAVIGATION_NEWS_TESTS,
          NAVIGATION_NEWS_ACTUALITY,
          NAVIGATION_NEWS_REPORTAGE,
          NAVIGATION_NEWS_VIDEOS
        ]
      }
    ]
  },
  {
    hideOnMobile: true,
    icon: 'calculator',
    label: 'NAVIGATION_MAIN_SERVICES_MOTOS_TITLE',
    menu: [
      {
        links: [
          {
            text: 'NAVIGATION_MAIN_SERVICES_MOTOS_SEARCH_ADVICES_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_MOTOS_SEARCH_ADVICES_URL'
          },
          {
            text: 'NAVIGATION_MAIN_SERVICES_MOTOS_CAR_REPORT_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_MOTOS_CAR_REPORT_URL'
          },
          {
            isExternal: true,
            text: 'NAVIGATION_MAIN_SERVICES_MOTOS_MILANUNCIOS_GARAGES_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_MOTOS_MILANUNCIOS_GARAGES_URL'
          }
        ]
      },
      {
        links: [
          {
            text: 'NAVIGATION_MAIN_SERVICES_MOTOS_INSURANCE_TEXT',
            url: 'NAVIGATION_MAIN_SERVICES_MOTOS_INSURANCE_URL',
            trackingData: {
              event: 'Event Fired',
              data: {
                channel: 'marketplace insurances',
                event_id: 'insurances home menu clicked'
              }
            }
          }
        ]
      }
    ]
  }
]

/**
 * @exports cTA
 */
export const cTA = {
  text: 'NAVIGATION_CTA_MOTOS_TEXT',
  url: 'NAVIGATION_CTA_MOTOS_URL'
}

/**
 * @exports cTALogin
 */
export const cTALogin = {
  text: 'NAVIGATION_CTA_LOGIN_MOTOS_TEXT',
  loginModalAction: true
}

export const userArea = {
  menuHead: {
    ...USER_EDIT_LINK
  },
  menuItems: [
    {
      ...USER_FAVORITES_LINK,
      iconName: 'IconHeartEmpty'
    },
    {
      ...USER_LOGOUT_LINK,
      iconName: 'IconLogout'
    }
  ]
}

/**
 * @exports user
 */
export const user = {
  hideNavUserInMobile: false,
  loggedIn: [
    {
      ...USER_EDIT_LINK,
      icon: 'userFilled'
    },
    {
      ...USER_FAVORITES_LINK,
      icon: 'heartFull'
    },
    {
      id: 'unseenSavedSearches',
      ...USER_ALERTS_LINK,
      icon: 'bellCheck'
    },
    {
      id: 'unreadMessages',
      ...USER_MESSAGES_LINK,
      icon: 'comments'
    },
    {
      id: 'pendingPta',
      ...USER_ADS_LINK,
      icon: 'checkbox'
    },
    {
      ...cTA,
      icon: 'ad-moto',
      hideOnMobile: true
    },
    {
      ...USER_LOGOUT_LINK,
      icon: 'logout'
    }
  ],
  loggedOut: [
    {
      text: 'NAVIGATION_USER_MOTOS_SIGN_IN_TEXT',
      url: 'NAVIGATION_USER_MOTOS_SIGN_IN_URL',
      icon: 'userFilled'
    },
    {
      text: 'NAVIGATION_USER_MOTOS_FAVORITES_TEXT',
      url: 'NAVIGATION_USER_MOTOS_FAVORITES_URL',
      icon: 'heartFull'
    },
    {
      ...cTA,
      icon: 'ad-moto',
      hideOnMobile: true
    },
    {
      hideOnMobile: true,
      text: 'NAVIGATION_USER_MOTOS_PROFESSIONAL_TEXT',
      url: 'NAVIGATION_USER_MOTOS_PROFESSIONAL_URL',
      icon: 'certificationLabel'
    }
  ]
}
